export const ADDON_LIST_REQUEST = "ADDON_LIST_REQUEST";
export const ADDON_LIST_SUCCESS = "ADDON_LIST_SUCCESS";
export const ADDON_LIST_FAIL = "ADDON_LIST_FAIL";
export const ADDON_LIST_RESET = "ADDON_LIST_RESET";

export const ADDON_SINGLE_REQUEST = "ADDON_SINGLE_REQUEST";
export const ADDON_SINGLE_SUCCESS = "ADDON_SINGLE_SUCCESS";
export const ADDON_SINGLE_FAIL = "ADDON_SINGLE_FAIL";
export const ADDON_SINGLE_RESET = "ADDON_SINGLE_RESET";

export const CREATE_ADDON_REQUEST = "CREATE_ADDON_REQUEST";
export const CREATE_ADDON_SUCCESS = "CREATE_ADDON_SUCCESS";
export const CREATE_ADDON_FAIL = "CREATE_ADDON_FAIL";
export const CREATE_ADDON_RESET = "CREATE_ADDON_RESET";

export const UPDATE_ADDON_REQUEST = "UPDATE_ADDON_REQUEST";
export const UPDATE_ADDON_SUCCESS = "UPDATE_ADDON_SUCCESS";
export const UPDATE_ADDON_FAIL = "UPDATE_ADDON_FAIL";
export const UPDATE_ADDON_RESET = "UPDATE_ADDON_RESET";

export const DELETE_ADDON_REQUEST = "DELETE_ADDON_REQUEST";
export const DELETE_ADDON_SUCCESS = "DELETE_ADDON_SUCCESS";
export const DELETE_ADDON_FAIL = "DELETE_ADDON_FAIL";
export const DELETE_ADDON_RESET = "DELETE_ADDON_RESET";
